import { render, staticRenderFns } from "./materialCombination.vue?vue&type=template&id=11f6fdd7&scoped=true"
import script from "./materialCombination.vue?vue&type=script&lang=js"
export * from "./materialCombination.vue?vue&type=script&lang=js"
import style0 from "./materialCombination.vue?vue&type=style&index=0&id=11f6fdd7&prod&lang=scss&scoped=true"
import style1 from "./materialCombination.vue?vue&type=style&index=1&id=11f6fdd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f6fdd7",
  null
  
)

export default component.exports